<div>
    <mat-button-toggle-group class="toggle" #group="matButtonToggleGroup" [value]="getStringValue(value)"
        (change)="onChange(group)">
        <mat-button-toggle *ngFor="let option of options" [value]="getStringValue(option.value)">{{option.key}}
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>